// Legend Modal - Message type color explanations

// Meshtastic-inspired color palette for message types
const MESSAGE_COLORS = [
  { name: 'Default', value: '#22d3ee', description: 'Standard mesh traffic' },
  { name: 'Position', value: '#10b981', description: 'GPS location updates' },
  { name: 'Text', value: '#3b82f6', description: 'Chat messages' },
  { name: 'Telemetry', value: '#8b5cf6', description: 'Device metrics & sensors' },
  { name: 'Admin', value: '#f59e0b', description: 'Network configuration' },
  { name: 'Emergency', value: '#ef4444', description: 'Critical alerts' },
];

export function LegendModal() {
  return (
    <div className="space-y-3">
      <div className="mb-3">
        <h3 className="text-sm font-semibold text-white mb-1">Message Types</h3>
        <p className="text-xs text-zinc-400">Meshtastic-inspired color coding</p>
      </div>

      <div className="space-y-2.5">
        {MESSAGE_COLORS.map((color) => (
          <div key={color.value} className="flex items-start gap-2.5 text-xs">
            <div 
              className="w-3 h-3 rounded-full mt-0.5 flex-shrink-0 ring-1 ring-white/20" 
              style={{ backgroundColor: color.value }}
            />
            <div>
              <div className="text-zinc-300 font-medium">{color.name}</div>
              <div className="text-zinc-500 text-[11px] leading-relaxed">{color.description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="pt-3 mt-3 border-t border-zinc-800 text-zinc-500 text-[11px] leading-relaxed">
        <p className="mb-2">
          <strong className="text-zinc-400">Flood Routing:</strong> Messages hop from node to node across the mesh until reaching their destination, just like Meshtastic networks.
        </p>
        <p className="text-zinc-600">
          Watch packets pulse as they travel through the network — each hop brings the message closer to its target.
        </p>
      </div>
    </div>
  );
}

